export type AvailableWeek = Record<string, AvailableTime[]>

export type AvailableTime = {
  start: string
  ende: string
}

export enum AvailableTimesActionTypes {
  FETCH_REQUEST = '@@availableTimes/FETCH_REQUEST',
  FETCH_SUCCESS = '@@availableTimes/FETCH_SUCCESS',
  FETCH_ERROR = '@@availableTimes/FETCH_ERROR',
  SELECT_DATE = '@@availableTimes/SELECT_DATE',
  SELECT_AVAILABLE_TIME = '@@availableTimes/SELECT_AVAILABLE_TIME',
  CLEAR_SELECTED = '@@availableTimes/CLEAR_SELECTED'
}

// Declare state types with `readonly` modifier to get compile time immutability.
// https://github.com/piotrwitek/react-redux-typescript-guide#state-with-type-level-immutability
export interface AvailableTimesState {
  readonly loading: boolean
  readonly data: AvailableWeek
  readonly selectedDate: Date
  readonly selectedTime?: AvailableTime
  readonly errors?: string
}
